import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styles from "./ServicesGrid.module.scss";
export const ServicesGrid = ({ children }) => {
    const childrenArray = React.Children.toArray(children);
    const count = childrenArray.length;
    return (_jsx("div", { className: styles.container, children: _jsx("div", { className: `${styles.grid} ${styles[`items-${count}`]}`, children: children }) }));
};
//# sourceMappingURL=ServicesGrid.js.map